import { IMessageDto } from '@/Models/Chat'
import React from 'react'
import { Map, Placemark } from 'react-yandex-maps';

type Props = {
  data: IMessageDto;
  isSender: boolean;
}

const LocationMessage = ({ data, isSender }: Props) => {
  const [lat, long] = data.text.split(',');

  return (
    <div className='chat-messages__item chat-messages__location' style={{ alignSelf: isSender ? 'flex-end' : 'flex-start' }}>
      <Map
        defaultState={{ center: [+lat, +long],  zoom: 13 }}
        width={200}
        height={133}
      >
        <Placemark geometry={[+lat, +long]} />
      </Map>
    </div>
  )
}

export default LocationMessage;
